import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper/core'
import { ClosePin, Plus } from '../icons'
import styles from './Gallery.module.sass'
import Container from '../Container'
import AssignId from '../AssignId'
import VisibilitySensor from '../VisibilitySensor'
import { useMediaQuery } from '@material-ui/core'
import { GalleryPageConfig } from '../configuration'

SwiperCore.use([Pagination]);

export default function Gallery() {

  const { id, title, description, items } = GalleryPageConfig;
  const [openPoint, setOpenPoint] = useState(null)
  const isMobile = useMediaQuery('(max-width: 760px)')

  return (
    <div className={styles.root}>
      <AssignId
        absolute
        y='-120px'
        yMobile='-80px'
        id={id}
      />
      <VisibilitySensor index={5} />
      <Container>
        <div className={`${styles.content} scroll-fadein`}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </Container>
      <div className={`${styles.slider} scroll-fadein-late`}>
        <Swiper 
          slidesPerView={1} 
          initialSlide={0}
          spaceBetween={40} 
          loop={isMobile}
          pagination={{ clickable: true }}
          className={styles.swiper}
          breakpoints={{
            768: {
              slidesPerView: "auto"
            }
          }}
        >
          {items.map(x => (
            <SwiperSlide key={x.key}>
              <div className={styles.item}>
                <img src={x.image} alt={x.alt} className={styles.itemImage} onClick={() => setOpenPoint(null)} />
                {x.points?.map(p => (
                  <div key={p.key} className={`${styles.point} ${p.xside ? styles[`point--${p.xside}`] : ""} ${p.yside ? styles[`point--${p.yside}`] : ""} ${openPoint?.key === p.key ? styles['point--open'] : ""}`} style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                    <button className={styles.pointTrigger}
                    onClick={() => {
                      setOpenPoint(openPoint?.key === p.key ? null : p);
                      if (window.dataLayer) {
                        window.dataLayer.push({
                          'event': 'lp_cta_body',
                          'cta_clicked': '+ ' + p.variantdl,
                          'section': 'Osmos'
                        });
                      }
                    }}
                    style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                      <span className={styles.pointTriggerIcon}>
                        <Plus />
                      </span>
                    </button>

                    



<div className={styles.pointContent}>
  <div className={styles.pointImageBox}>
    <img src={p.thumb} className={styles.pointImage} />
  </div>
  <button className={styles.pointClose} onClick={() => setOpenPoint(null)}>
    <ClosePin />
  </button>
  <div className={styles.pointInfoBox}>   <p className={styles.pointDescription}>
    {p.description}</p>
    <p className={styles.pointVariant} dangerouslySetInnerHTML={{ __html: p.variant }} />  
  </div>
</div>



                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}